import { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import PrivateRoute from 'components/AppGuards/PrivateRoute';
import AuthRouter from 'routes/AuthRoutes';
import Spinner from 'components/Common/Spinner';
import * as urls from 'routes/config';
import PageNotFound from 'containers/Public/Exceptions/PageNotFound';
import EmbedPreview from 'containers/Public/EmbedPreview';
import PreviewLink from 'containers/Public/PreviewLink';
import AllowToAgencyUser from 'components/AppGuards/AllowToAgencyUser';

import OnboardLayout from 'components/Layouts/OnboardLayout';
import AppLayout from 'components/Layouts/AppLayout';
import AgencyLayout from 'components/Layouts/AgencyLayout';
import BusinessLayout from 'components/Layouts/BusinessLayout';
import Profile from 'containers/UserProfile';
import AgentRoutes from 'routes/Business/Agent';
import AgencyRoutes from 'routes/Agency';
import BusinessSettingRoutes from 'routes/Business/Setting';
import CreateAgent from 'containers/Business/Agent/CreateAgent/CreateAgent';
import SelectAgent from 'containers/Business/Agent/SelectAgent/SelectAgent';
import Home from 'containers/Home/Home';
import WorksheetRoutes from './Business/Worksheet/Index';
import WorksheetLayout from 'components/Layouts/WorksheetLayout';
import Welcome from 'containers/Home/Welcome';

export default function MainRoutes() {
  return (
    <Suspense fallback={<Spinner />}>
      <Routes>
        {/* Auth Routes */}
        <Route path={`${urls.auth.base}/*`} element={<AuthRouter />} />
        <Route path='/welcome' element={<Welcome />} />

        <Route path='/' element={<PrivateRoute outlet={<Home />} />} />

        {/* Public link */}
        <Route path={urls.publicRoutes.embedPreview} element={<EmbedPreview />} />
        <Route path={urls.publicRoutes.previewLink()} element={<PreviewLink />} />

        {/* Create Agent Route */}
        <Route
          path={`${urls.base()}/${urls.onBoarding.create}`}
          element={
            <PrivateRoute
              outlet={
                <OnboardLayout>
                  <CreateAgent />
                </OnboardLayout>
              }
            />
          }
        />

        {/* Select Agent Route */}
        <Route
          path={`${urls.base()}/${urls.onBoarding.selectAgent}`}
          element={
            <PrivateRoute
              outlet={
                <OnboardLayout>
                  <SelectAgent />
                </OnboardLayout>
              }
            />
          }
        />

        {/* Business Routes */}
        <Route
          path={`${urls.business.base}/*`}
          element={
            <PrivateRoute
              outlet={
                // AllowWhenSubscribed removed
                <BusinessLayout>
                  <BusinessSettingRoutes />
                </BusinessLayout>
              }
            />
          }
        />

        {/* Agent Routes */}
        <Route
          index
          path={`${urls.agentBase()}/*`}
          element={
            <PrivateRoute
              outlet={
                // AllowWhenSubscribed removed
                <AppLayout>
                  <AgentRoutes />
                </AppLayout>
              }
            />
          }
        />

        <Route
          index
          path={`${urls.worksheetBase()}/*`}
          element={
            <PrivateRoute
              outlet={
                // AllowWhenSubscribed removed
                <WorksheetLayout>
                  <WorksheetRoutes />
                </WorksheetLayout>
              }
            />
          }
        />

        {/* Agency routes */}
        <Route
          index
          path={`${urls.agency.base}/*`}
          element={
            <AllowToAgencyUser
              outlet={
                <AgencyLayout>
                  <AgencyRoutes />
                </AgencyLayout>
              }
            />
          }
        />

        {/* Profile Route */}
        <Route path={`${urls.base()}/${urls.home.profile}`} element={<PrivateRoute outlet={<Profile />} />} />

        <Route path='/404' element={<PageNotFound />} />
        <Route path='*' element={<Navigate to='/404' replace />} />
      </Routes>
    </Suspense>
  );
}
